import {
  Create,
  SimpleForm,
  TextInput,
  required,
  SelectInput,
  useRedirect,
  useNotify,
} from 'react-admin';
import { useCallback } from 'react';
import { getToken, getRefreshToken } from '../authentication/authProvider';

export const QuoteCreate = () => {
  const redirect = useRedirect();
  const notify = useNotify();

  const transform = useCallback((data: any) => {
    return {
      deceased_full_name: `${data.deceased_first_name} ${data.deceased_last_name}`,
      next_of_kin_full_name: `${data.primary_client_first_name} ${data.primary_client_last_name}`,
      email: data.email,
      phone_number: data.phone_number,
      language: data.language,
    };
  }, []);

  const save = useCallback(async (values: any) => {
    try {
      const transformedData = transform(values);
      const result = await fetch(
        `${process.env.REACT_APP_PAPERMAN_API_URL}quotes`,
        {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            Authorization: `Bearer ${await getToken()}`,
            'Refresh-Token': await getRefreshToken(),
          },
          body: JSON.stringify(transformedData),
        }
      );

      if (result.status >= 200 && result.status < 300) {
        notify('Quote created successfully', { type: 'success' });
        redirect('list', 'quotes');
      } else {
        const body = await result.json();
        notify(
          `Error creating quote: ${body.message || 'Unknown error'}`,
          { type: 'error' }
        );
      }
    } catch (error) {
      console.error('Error creating quote:', error);
      notify('Error creating quote', { type: 'error' });
    }
  }, [transform, notify, redirect]);

  return (
    <Create>
      <SimpleForm onSubmit={save}>
        <TextInput source="deceased_first_name" fullWidth label="Deceased First Name" />
        <TextInput source="deceased_last_name" fullWidth label="Deceased Last Name" />
        <TextInput source="primary_client_first_name" fullWidth label="Primary Client First Name" />
        <TextInput source="primary_client_last_name" fullWidth label="Primary Client Last Name" />
        <TextInput source="email" fullWidth />
        <TextInput source="phone_number" fullWidth />
        <SelectInput 
          source="language" 
          choices={[
            { id: 'en', name: 'English' },
            { id: 'fr', name: 'French' }
          ]}
          validate={[required()]}
        />
      </SimpleForm>
    </Create>
  );
}; 